export default __webpack_public_path__ + "static/media/grove.515f70ba.svg";